import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'
import App from 'src/App'
import router from 'src/router'
import store from 'src/store'

import VuetifyPlugin from 'src/plugins/vuetify'
import SocketPlugin from 'src/plugins/socket'
import i18n from 'src/plugins/i18n'

import Config from 'src/config'

Vue.config.productionTip = false
Vue.prototype.$config = Config

SocketPlugin({ Vue, store })
const vuetify = VuetifyPlugin({ Vue })

const vue = new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')

export default vue
